import React from 'react';
import PropTypes from 'prop-types';


const shareIconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
  hoverEffect: PropTypes.bool,
  onClick: PropTypes.func,
};

const shareIconDefaultProps = {
  size: 50,
  fill: null,
  style: {},
  hoverEffect: true,
};

const ShareIcon = ({ fill, size, className, id, style, onClick, children }) => {
  const mergedStyles = {
    ...style,
    ...(fill ? { fill: fill } : {}),
    ...(onClick ? { cursor: 'pointer' } : {}),
  };
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 50 50"
      width={size}
      height={size}
      className={className}
      id={id}
      style={mergedStyles}
      onClick={onClick || (() => {})}
    >
      {children}
    </svg>
  );
};

const Share = ({ className, ...rest }) => (
  <ShareIcon className={`share-icon-share ${className}`} {...rest}>
    <path d="M41.9,33.8a8,8,0,0,0-6,2.75L16,26.64a8.48,8.48,0,0,0,0-3.28l19.82-9.91a8,8,0,0,0,6,2.75A8.06,8.06,0,1,0,34,9.74L14.14,19.65a8,8,0,0,0-6-2.75,8.1,8.1,0,1,0,6,13.45L34,40.26A8.1,8.1,0,1,0,41.9,33.8Z" />
  </ShareIcon>
);
Share.propTypes = shareIconPropTypes;
Share.defaultProps = shareIconDefaultProps;

const Email = ({ className, ...rest }) => (
  <ShareIcon className={`share-icon-email ${className}`} {...rest}>
    <path d="M25 0a25 25 0 1 0 25 25A25 25 0 0 0 25 0zm14 32.88c0 1.44-1.18 2.62-2.62 3.55H13.62C12.18 35.5 11 34.32 11 32.88V22.7a.33.33 0 0 1 .53-.26c1.23.95 2.85 2.16 8.43 6.21 1.15.84 3.1 2.62 5 2.61s3.94-1.8 5.05-2.61c5.58-4 7.19-5.26 8.42-6.22a.33.33 0 0 1 .53.26zm0-15.65a1.3 1.3 0 0 1-.5 1c-1.68 1.32-2.23 1.78-9.49 7-.91.67-2.74 2.29-4 2.27S21.9 26 21 25.3c-7.26-5.26-7.81-5.73-9.49-7a1.32 1.32 0 0 1-.5-1v-1a2.62 2.62 0 0 1 2.62-2.62h22.75A2.62 2.62 0 0 1 39 16.19z" />
  </ShareIcon>
);
Email.propTypes = shareIconPropTypes;
Email.defaultProps = shareIconDefaultProps;

const Embed = ({ className, ...rest }) => (
  <ShareIcon className={`share-icon-embed ${className}`} {...rest}>
    <path d="M25 0a25 25 0 1 0 25 25A25 25 0 0 0 25 0zm-8.24 32.61a.63.63 0 0 1-.9 0L8.2 25.46a.64.64 0 0 1 0-.93l7.66-7.17a.63.63 0 0 1 .9 0l2.31 2.46a.64.64 0 0 1 0 .92L14.22 25 19 29.23a.64.64 0 0 1 0 .92zm6.85 5.53a.63.63 0 0 1-.79.43l-3.24-.94a.64.64 0 0 1-.44-.79l7.25-25a.63.63 0 0 1 .79-.43l3.24.94a.64.64 0 0 1 .44.79zM41.8 25.47l-7.66 7.17a.63.63 0 0 1-.9 0l-2.31-2.46a.64.64 0 0 1 0-.92L35.78 25 31 20.76a.63.63 0 0 1 0-.91l2.31-2.47a.65.65 0 0 1 .9 0l7.66 7.19a.64.64 0 0 1-.07.9z" />
  </ShareIcon>
);
Embed.propTypes = shareIconPropTypes;
Embed.defaultProps = shareIconDefaultProps;

const Facebook = ({ className, ...rest }) => (
  <ShareIcon className={`share-icon-facebook ${className}`} {...rest}>
    <path d="M25 0a25 25 0 1 0 25 25A25 25 0 0 0 25 0zm8.77 13.64h-3.21c-2.51 0-3 1.2-3 2.95v4.16h5.66l-.77 6h-4.88V42h-6.24V26.79h-5.1v-6h5.1V16c0-5.17 3.16-8 7.77-8a43.72 43.72 0 0 1 4.67.24z" />
  </ShareIcon>
);
Facebook.propTypes = shareIconPropTypes;
Facebook.defaultProps = shareIconDefaultProps;

const GooglePlus = ({ className, ...rest }) => (
  <ShareIcon className={`share-icon-googleplus ${className}`} {...rest}>
    <path d="M25 0a25 25 0 1 0 25 25A25 25 0 0 0 25 0zm-7.13 37.5a12.5 12.5 0 0 1 0-25 12.07 12.07 0 0 1 8.37 3.26L22.85 19a7.08 7.08 0 0 0-5-1.92 7.87 7.87 0 0 0 0 15.74c3.29 0 6.55-1.92 7.07-5.37h-7.05V23.2h11.79a11 11 0 0 1 .19 2.08c0 7.14-4.79 12.22-12 12.22zm23.21-10.71v3.58H37.5v-3.58h-3.58v-3.57h3.58v-3.58h3.58v3.58h3.55v3.57z" />
  </ShareIcon>
);
GooglePlus.propTypes = shareIconPropTypes;
GooglePlus.defaultProps = shareIconDefaultProps;

const LinkedIn = ({ className, ...rest }) => (
  <ShareIcon className={`share-icon-linkedin ${className}`} {...rest}>
    <path d="M25 0a25 25 0 1 0 25 25A25 25 0 0 0 25 0zm-8.28 40H10.5V20h6.22zM13.6 17.24a3.62 3.62 0 1 1 3.6-3.63 3.63 3.63 0 0 1-3.6 3.63zM40 40h-6.21v-9.75c0-2.32 0-5.3-3.24-5.3s-3.73 2.52-3.73 5.13V40h-6.21V20h6v2.7h.08a6.54 6.54 0 0 1 5.89-3.23c6.26 0 7.42 4.14 7.42 9.53z" />
  </ShareIcon>
);
LinkedIn.propTypes = shareIconPropTypes;
LinkedIn.defaultProps = shareIconDefaultProps;

const Twitter = ({ className, ...rest }) => (
  <ShareIcon className={`share-icon-twitter ${className}`} {...rest}>
    <path d="M25 0a25 25 0 1 0 25 25A25 25 0 0 0 25 0zm14.11 19.28v.88c0 8.94-6.81 19.24-19.24 19.24a19.07 19.07 0 0 1-10.39-3 12.53 12.53 0 0 0 1.63.09 13.56 13.56 0 0 0 8.4-2.89 6.76 6.76 0 0 1-6.32-4.69 8.71 8.71 0 0 0 1.27.1 7 7 0 0 0 1.78-.23 6.76 6.76 0 0 1-5.42-6.63V22a6.83 6.83 0 0 0 3.06.86 6.78 6.78 0 0 1-2.1-9 19.21 19.21 0 0 0 14 7.08 7.22 7.22 0 0 1-.17-1.55 6.78 6.78 0 0 1 11.71-4.63 13.19 13.19 0 0 0 4.29-1.63 6.76 6.76 0 0 1-3 3.73 13.41 13.41 0 0 0 3.89-1 14.45 14.45 0 0 1-3.39 3.42z" />
  </ShareIcon>
);
Twitter.propTypes = shareIconPropTypes;
Twitter.defaultProps = shareIconDefaultProps;

export {
  Share,
  Email,
  Embed,
  Facebook,
  GooglePlus,
  LinkedIn,
  Twitter,
};



// WEBPACK FOOTER //
// ./src/components/Icons/shareIcons.js